import React from 'react';
export function SupportingTestimonials() {
  const testimonials = [{
    quote: "We knew AI was going to change how we worked, but we didn't have a foundation or a strategy for it. Working with Michael helped us develop both in a thoughtful and meaningful way. He quickly established rapport with our diverse team, and he brought a hands-on approach that got even our most resistant team members engaging with AI productively. The work established a foundation that the firm is able to continue building on.",
    author: 'Kate Grimes',
    role: 'Former Director, Snøhetta',
    initials: 'KG',
    image: ''
  }, {
    quote: "Unlike previous training efforts that weren't applicable to daily work, Michael's approach was practical and meaningful. Our product teams are now much more curious about AI and it's become part of their regular workflow.",
    author: 'Carsten Wierwille',
    role: 'VP of Product and Design, HTEC Group',
    initials: 'CW',
    image: 'https://cdn.magicpatterns.com/uploads/qW1THK3pnfcFH8HpCxBkjb/image.jpg'
  }, {
    quote: "The course didn't just teach me tools — it gave me the strategic foundation and confidence to take on AI leadership roles. Seven months later, I'm leading our AI development team and presenting AI roadmaps to enterprise clients.",
    author: 'Kate Mosley',
    role: 'Group Product Manager',
    initials: 'KM',
    image: 'https://cdn.magicpatterns.com/uploads/dZbRkgqJwtFqwChPqoMTqs/image.jpg'
  }, {
    quote: 'This class is a cheat code for Product Managers and Leaders who need to accelerate their understanding and use of AI to build and ship in this new era.',
    author: 'John',
    role: 'Digital Media Product Consultant',
    initials: 'J',
    image: 'https://cdn.magicpatterns.com/uploads/kQaBmYBGxdKgGbxNz9YDez/image.jpg'
  }];
  return <section className="w-full bg-brand-warm-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-432" data-mp="m082cyohxb28">
      <div className="max-w-7xl mx-auto" data-id="element-433" data-mp="3a7ztni1z5k00">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-434" data-mp="3e93dsgr22271">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-10 rounded-lg shadow-sm border-l-4 border-brand-orange flex flex-col h-full" data-id="element-435" data-mp="30a3lmz4c3564" data-mpi={index}>
              <blockquote className="text-brand-navy text-lg leading-relaxed mb-10 flex-grow italic" data-id="element-436" data-mp="2qjiq5kjyigrf">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-3" data-id="element-437" data-mp="2vbil0yl66jh5">
                <div className="w-10 h-10 rounded-full bg-brand-light-gray border border-gray-200 flex items-center justify-center flex-shrink-0 overflow-hidden" data-id="element-438" data-mp="2hjce833wpoud">
                  {testimonial.image ? <img src={testimonial.image} alt={testimonial.author} className="w-full h-full object-cover" data-id="element-439" data-mp="27kd5yln1zv7w" /> : <span className="text-brand-gray-light text-xs font-bold" data-id="element-440" data-mp="1syg3lz21rntw">
                      {testimonial.initials}
                    </span>}
                </div>
                <div data-id="element-441" data-mp="22wwxb3sdegjn">
                  <div className="font-bold text-brand-navy" data-id="element-442" data-mp="22xf0ylhd3x1l">
                    {testimonial.author}
                  </div>
                  <div className="text-brand-gray-light text-sm" data-id="element-443" data-mp="2bwsdxo4p33r2">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}